export const fetchOrderStatus = async (redemptionToken: string) => {
  return fetch('/order_status', {
    method: 'POST',
    body: JSON.stringify({
      redemptionToken,
    }),
    headers: {
      'Sec-Fetch-Dest': 'empty',
    },
  });
};
